import EventInfoService from '../../../../../../components/base/infoServices/EventInfoService';
import _ from 'lodash';
import { ManualInjector } from '../../../../../manual-injector';
export default class EventSelect {
    static load({ evTriggerSelectMode, customKey, customDescription, filterOnProperty1, filterOnProperty2 }) {
        const eventInfoService = ManualInjector.injector.get(EventInfoService);
        const events = _.map(eventInfoService.eventsConfig.definitions, ({ eventName, title }) => ({ eventName, title }));
        return {
            label: 'Event',
            description: customDescription || 'Select event. List filtered by Equipment or Equipment Type.',
            key: customKey || 'event',
            type: 'select',
            multi: false,
            validate: {
                required: true
            },
            dataSrc: 'custom',
            valueProperty: 'value',
            refreshOn: filterOnProperty1,
            clearOnRefresh: true,
            customOptions: {
                searchResultLimit: 10
            },
            data: {
                custom: (scope) => {
                    const values = _.transform(events, (memo, { eventName, title }) => {
                        let shouldPush = true;
                        if (filterOnProperty1 || filterOnProperty2) {
                            const eqType = eventName.split('/')[0];
                            const prop1 = _.get(scope, ['data', filterOnProperty1, 'equipmentType']);
                            const prop2 = _.get(scope, ['data', filterOnProperty2]);
                            shouldPush = eqType === prop1 || eqType === prop2;
                        }
                        if (shouldPush) {
                            memo.push({
                                label: `${title} (${eventName})`,
                                value: evTriggerSelectMode ? {
                                    type: 'equals',
                                    pattern: eventName
                                } : eventName
                            });
                        }
                    }, []);
                    return values;
                }
            }
        };
    }
}
